module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMyAxMzYgMzEuMSA2MTggOTk1IDYxOFpNMjAwLjYgNTk0LjNsMCAyOTMuNyAxMDUuNSAwYzQ5LjgtMTM3LjggMTI0LTIyNS4yIDIwNi45LTIyNS4yIDgyLjkgMCAxNTcuMSA4Ny40IDIwNi45IDIyNS4ybDEwNS41IDBMODI1LjQgNTk0LjMgMjAwLjYgNTk0LjN6IiBwLWlkPSI3MDUiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/home2.svg
// module id = qiOA
// module chunks = 74